export const formatReferralCode = (code: string): string => {
  const formattedCode = code.startsWith("R")
    ? `R${code.slice(1).replace(/\D/g, "")}`
    : `R${code.replace(/\D/g, "")}`;

  const numericPart = formattedCode.slice(1).replace(/\D/g, "").substring(0, 11);

  const formattedNumericPart = numericPart.replace(
    /^(\d{3})(\d{0,4})?(\d{0,4})?$/,
    (_, p1, p2, p3) => {
      return [p1, p2, p3].filter(Boolean).join("-");
    }
  );

  return `R${formattedNumericPart}`;
};
